import { createSlice, configureStore } from "@reduxjs/toolkit";
import { Modal } from "antd";

const defaultState = {
  uploadModalOpen: true, // 上传解析弹窗是否打开
};

const AIReducerV7 = createSlice({
  name: "AIV7",
  initialState: {
    value: 0,
    uploadModalOpen: false, // 上传弹窗是否打开
    QAKowledgeList: [], // 添加至问答的知识列表
    refreshSpaceList: false, //更新知识中心的个人资料列表
    aiQAParams: {}, // ai问答的参数
  },
  reducers: {
    setAIModalState: (state, action) => {
      for (let key in action.payload) {
        state[key] = action.payload[key];
      }
    },
    setQAKowledgeList: (state, action) => {

      let disabled = true, text = '';

      if(state.QAKowledgeList.length > 0 ){
        let newKnowledgeTypeId = action.payload[action.payload.length-1].knowledgeTypeId;
        let oldKnowledgeTypeId = state.QAKowledgeList[0].knowledgeTypeId;
        if(
          (newKnowledgeTypeId === '4' && oldKnowledgeTypeId !== '4') ||
          (newKnowledgeTypeId != '4' && oldKnowledgeTypeId === '4')
        ){
          // 政策跟踪
          text = "政策跟踪文件不能和其他知识类型文件同时添加"
          disabled = false;
        }else if(
          (newKnowledgeTypeId === '7' && oldKnowledgeTypeId !== '7') ||
          (newKnowledgeTypeId != '7' && oldKnowledgeTypeId === '7')
        ){
          // 参考研报
          text = "参考研报文件不能和其他知识类型文件同时添加"
          disabled = false;
        }
      }

      if(disabled){
        const uniqueData = uniqueObjects(action.payload);
        state.QAKowledgeList = uniqueData;
      }else{
        Modal.warning({
          title: '提示',
          content: text,
        });
      }
    },
    getAIModalState: (state, action) => {
      state.downloadModalStatus = action.payload;
    },
    // 通知更新购物车数量
    refreshAIcarNumF: (state, action) => {
      state.refreshAIcarNum = action.payload;
    },
    refreshPublicKnowledge: (state, action) => {
      state.publicKnowledge = action.payload;
    },
    getData: (state, action) => {
      // Redux Toolkit 允许在 reducers 中编写 "mutating" 逻辑。
      // 它实际上并没有改变 state，因为使用的是 Immer 库，检测到“草稿 state”的变化并产生一个全新的
      // 基于这些更改的不可变的 state。
      console.log(state);
      return state;
    },
    // 当关闭AI问答弹窗的时候 重置数据
    resetAiData:(state, action)=>{
      return defaultState;
    }
  },
});

const uniqueObjects = (arr) => {
    return arr.filter((item, index, self) => {
        return self.findIndex(t => t.id === item.id) === index;
    });
}

export const { setAIModalState, setQAKowledgeList, getAIModalState, refreshAIcarNumF, refreshPublicKnowledge, getData, resetAiData } = AIReducerV7.actions;

export default AIReducerV7.reducer;